
// angular.module('mtic')
//   .constant('ERROR_CODES', {
//   "LOGIN" : {
//     "MISSING_PARAMETERS": "Please fill in both username and password",
//     "NOT_FOUND__USER_AUTHS": "Username is not found",
//     "BAD_PASSWORD": "Invalid Password"
//   },
//   "SIGNUP": {
//     "MISSING_PARAMETERS": "Please complete all fields to sign up",
//     "NOT_FOUND_ACCESS_CODES": "The access code you entered is not valid",
//     "UUID_ALREADY_EXISTS": "This User name already exists",
//     "NOT_FOUND_USER_ROLES": "Invalid class code or teacher id"
//   },
//   "UNKNOWN": "Something went wrong, please check your internet connection"
//   })

angular.module('mtic')
  .constant('ERROR_CODES', {
  "LOGIN" : {
    "MISSING_PARAMETERS": "11306",
    "NOT_FOUND__USER_AUTHS": "11307",
    "BAD_PASSWORD": "11308"
  },
  "SIGNUP": {
    "MISSING_PARAMETERS": "11309",
    "NOT_FOUND_ACCESS_CODES": "11310",
    "UUID_ALREADY_EXISTS": "11311",
    "NOT_FOUND_USER_ROLES": "11312"
  },
  "UNKNOWN": "11313"
  })
